import {
  TESTIMONIAL_LANGUAGE,
  TESTIMONIAL_PROGRAM_INTERNAL_NAMES,
} from '../constants/featureFlags';

export type TestimonialGateInput = {
  /** Value of the OUTCOMES_BEFORE_COACH_SELECTION PostHog flag. */
  outcomesVariant: string | boolean | undefined;
  /** The enrolled program's coaching modality. */
  modality: 'individual' | 'group' | undefined;
  /** The enrolled program's `internalName`. */
  programInternalName: string | undefined;
  /** The user's `customerProfile.preferredLanguage`. */
  preferredLanguage: string | undefined;
};

/**
 * Whether the post-enrollment testimonial page should show, mirroring Sparta's
 * `postProgramInstanceRxAction` gate exactly: the OUTCOMES flag is on the `'test'`
 * variant, the program is individual coaching, its internalName is one of the
 * targeted programs, and the user's preferred language is en-US. All four must hold.
 */
export function shouldShowTestimonial({
  outcomesVariant,
  modality,
  programInternalName,
  preferredLanguage,
}: TestimonialGateInput): boolean {
  return (
    // 'test' is the enabled cohort of the OUTCOMES PostHog flag (vs 'control').
    outcomesVariant === 'test' &&
    modality === 'individual' &&
    TESTIMONIAL_PROGRAM_INTERNAL_NAMES.includes(programInternalName ?? '') &&
    preferredLanguage === TESTIMONIAL_LANGUAGE
  );
}
